export default {
  methods: {
    _isElementInViewport: function _isElementInViewport(el) {
      var rect = el.getBoundingClientRect();
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      /*or $(window).height() */
      && rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      /*or $(window).width() */
      ;
    },
    // From https://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
    $onVisibilityChange: function $onVisibilityChange(el, callback) {
      var isElementInViewport = this._isElementInViewport;
      var old_visible;

      var handler = function handler() {
        var visible = isElementInViewport(el);

        if (visible != old_visible) {
          old_visible = visible;
          callback(el, visible);
        }
      }; // Make sure it executes right away (e.g. during onReady())


      handler();
      return handler;
    }
  }
};